import React from "react";

const CONTENT = {
  title: "Подробнее",
  description: "Гиперпрессованный облицовочный кирпич «ВОК» производится на современном оборудовании. Производственная линия полностью автоматизирована. Мощность линии позволяет выпустить серийные проекты и дизайнерские решения заказчиков."
};

const AboutSection = () => (
  <div className='centered' style={{ flexDirection: 'column' }}>
    <h1 style={{color: '#404040'}}>{CONTENT.title}</h1> 
    <div>
      {CONTENT.description}
    </div>
  </div>
);

export default React.memo(AboutSection);